// Description phrase types
// Pre-defined default phrases (not stored in DB, defined in frontend)
export const DEFAULT_DESCRIPTION_PHRASES = [
    // Most common (user requested at top)
    "In it's original packaging (plastic wrap)",
    'Never opened',
    // Packaging-related
    'Original packaging',
    'Factory sealed',
    'Includes original box',
    'No original packaging',
    // Condition-related
    'Minor scratches',
    'Some surface scratches',
    'Light wear',
    'Shows signs of use',
    'Excellent condition',
    'Like new condition',
    'Some cosmetic damage',
    // Completeness
    'Includes all original accessories',
    'Missing accessories',
    'Complete set',
    // Testing/Function
    'Tested and working',
    'Not tested',
    'Powers on',
    'Fully functional',
    // Vinyl/Music specific
    'Original inner sleeve',
    'Gatefold sleeve',
    'Sleeve has ring wear',
    'Plays without skipping',
    'Some surface noise',
];
//# sourceMappingURL=phrase.js.map